const removeTrailingZeros = (input: string) => {
  let end: number = input.length;
  while (end > 0 && input[end - 1] === "0") {
    end--;
  }
  return input.substring(0, end);
};

export const getSortingVal = (
  sFrac: string | null | undefined,
  createdAt: number
) => {
  return sFrac ?? removeTrailingZeros(createdAt.toString());
};
